export default {
      id: "eye-gray-usage",
      viewBox: "0 0 52.061 52",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#eye-gray",
      toString: function () {
        return this.url;
      }
    }